import { type FC, useCallback } from "react";

import { cx } from "@emotion/css";
import { type DeltaStatic, type Sources } from "quill";
import ReactQuill, { type UnprivilegedEditor } from "react-quill";

import "react-quill/dist/quill.snow.css";

import { RichTextWrapper, richTextErrorCss } from "./AssetSubmission.styles";

interface RichTextEditorProps {
    value: string;
    onChange: (value: string) => void;
    onBlur?: () => void;
    placeholder?: string;
    hasError?: boolean;
}

const MODULES = {
    toolbar: [
        [{ header: [1, 2, 3, false] }],
        ["bold", "italic", "underline", "strike"],
        [{ list: "ordered" }, { list: "bullet" }],
        ["blockquote", "code-block"],
        ["link"],
        ["clean"],
    ],
};
const FORMATS = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "list",
    "bullet",
    "blockquote",
    "code-block",
    "link",
];

export const RichTextEditor: FC<RichTextEditorProps> = ({ value, onChange, onBlur, placeholder, hasError }) => {
    const handleChange = useCallback(
        (content: string, _delta: DeltaStatic, _source: Sources, editor: UnprivilegedEditor) => {
            // Quill emits "<p><br></p>" when visually empty — normalise to "" so `required` works.
            onChange(editor.getText().trim().length === 0 ? "" : content);
        },
        [onChange],
    );

    return (
        <RichTextWrapper className={cx(hasError && richTextErrorCss)}>
            <ReactQuill
                theme="snow"
                value={value}
                onChange={handleChange}
                onBlur={onBlur}
                placeholder={placeholder}
                modules={MODULES}
                formats={FORMATS}
            />
        </RichTextWrapper>
    );
};
